{
  "en": {
    "locale_field": {
      "fallback_tooltip": "When no text is entered for this language, this default text will be used as the fallback."
    }
  }
}
